import { Injectable } from '@angular/core';
import * as _ from 'lodash';


@Injectable({
    providedIn: 'root'
})
export class ValidationService {
    validateEmail(email: string) {
        const filter = new RegExp('^([\\w-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$');
        return filter.test(email);
    }

    validatePassword(password: string) {
        // Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one number.
        const filter = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.{8,})');
        return filter.test(password);
    }
}